import { BREAKPOINT_SIZES } from '../../../constants';

const getDynamicGridClasses = (grid, defaulItemsPerRow, breakpoints = {}) => {
  const { global: { breakpointConfig } = {} } = breakpoints;
  const defaultGrid = defaulItemsPerRow ? `${grid} grid-cols-${defaulItemsPerRow}` : grid;
  if (!breakpointConfig || !Object.keys(breakpointConfig).length) return defaultGrid;

  const wrapperBreakpoints = Object.keys(breakpointConfig)
    .map(size => {
      const { itemsPerRow } = breakpointConfig[size];
      if (!itemsPerRow) return '';
      const sizeString = BREAKPOINT_SIZES[size];
      return `${sizeString}:grid-cols-${itemsPerRow}`;
    })
    .filter(Boolean);
  return [defaultGrid, ...wrapperBreakpoints].join(' ');
};

export default getDynamicGridClasses;
